export enum FilterSelectionContainerType {
    Foreground,
    BackgroundMarket,
    BackgroundFleet,
}